import {UI, type PartialOptions} from "../../../stem-core/ui/UIBase";
import {styleRule, StyleSheet} from "../../../stem-core/ui/Style";
import {registerStyle} from "../../../stem-core/ui/style/Theme";
import {NOOP_FUNCTION} from "../../../stem-core/base/Utils.js";
import {ToggleInput} from "../../../stem-core/ui/input/checkbox/ToggleInput.jsx";
import type {UIChild} from "../../../stem-core/ui/UIBase";
import type {InputElementOptions} from "../../../stem-core/ui/input/BaseInputElement";

class LabeledToggleStyle extends StyleSheet {
    @styleRule
    container = {
        padding: "12px 0px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: 6,
    };

    @styleRule
    label = {
        fontSize: this.themeProps.FONT_SIZE_LARGE,
        color: this.themeProps.SETTINGS_LABEL_COLOR,
    }
}

interface LabeledToggleOptions {
    initialValue?: boolean;
    label?: UIChild;
    // Handed straight to the ToggleInput below
    onChange?: InputElementOptions<boolean>["onChange"];
}

@registerStyle(LabeledToggleStyle)
export class LabeledToggle extends UI.Element<LabeledToggleOptions> {
    getDefaultOptions(): PartialOptions<LabeledToggle> {
        return {
            ...super.getDefaultOptions(),
            onChange: NOOP_FUNCTION,
            initialValue: false,
            label: ""
        }
    }

    render() {
        const {styleSheet} = this;
        const {label, initialValue, onChange} = this.options;

        return [
            <div className={styleSheet.label}>
                {label}
            </div>,
            <ToggleInput initialValue={initialValue} onChange={onChange}/>
        ]
    }
}
